const GLOBAL_GOOGLE_MAP_API_CALLBACK_NAME = '__globalGoogleMapApiCallback';

const isLoaded = () => !!(window.google && window.google.maps);

const load = (() => {
    let result;

    return async ({ version, key, clientId }) => {
        if (!key && !clientId) {
            return new Promise((resolve, reject) => reject(false));
        }

        result =
            result ||
            new Promise((resolve, reject) => {
                if (isLoaded()) {
                    resolve(true);
                    return;
                }

                window[GLOBAL_GOOGLE_MAP_API_CALLBACK_NAME] = () => resolve(true);

                const script = document.createElement('script');
                script.src = `//maps.googleapis.com/maps/api/js?v=${version}${
                    clientId ? `&client=${clientId}` : `&key=${key}`
                }&callback=${GLOBAL_GOOGLE_MAP_API_CALLBACK_NAME}`;
                script.onerror = () => reject(false);

                document.head.appendChild(script);
            });

        return await result;
    };
})();

export default {
    isLoaded,
    load,
};
